/**
 * Rejects scripts that look like pasted non-narration (encoded blobs, long data runs).
 * Editorial quality or topic fit are intentionally out of scope.
 */
export function getFacelessScriptSanityMessage(script) {
    const trimmed = script.trim();
    if (!trimmed) {
        return null;
    }
    const longestToken = longestWhitespaceDelimitedTokenLength(trimmed);
    const maxSingleTokenChars = 400;
    if (longestToken >= maxSingleTokenChars) {
        return "Your script looks like pasted data rather than narration (very long uninterrupted segments). Split it into normal sentences or check you pasted the correct text.";
    }
    const compact = stripAllWhitespace(trimmed);
    const compactLower = compact.toLowerCase();
    if (compactLower.startsWith("data:") && compactLower.includes(";base64,")) {
        return "This looks like a data URL rather than narration. Paste the script you want read aloud.";
    }
    if (compact.length >= 200 && /^[0-9A-Fa-f]+$/.test(compact)) {
        return "This looks like hexadecimal or binary-safe data rather than narration. Paste a script meant to be spoken.";
    }
    if (compact.length >= 96 &&
        /[+/=]/.test(compact) &&
        /^[A-Za-z0-9+/]+=*$/.test(compact)) {
        return "This looks like encoded text (such as Base64), not something we can narrate as a reel. Paste the spoken script itself.";
    }
    if (compact.length >= 200) {
        let letters = 0;
        let digits = 0;
        for (const ch of compact) {
            if (/\p{L}/u.test(ch)) {
                letters++;
            }
            if (/\p{N}/u.test(ch)) {
                digits++;
            }
        }
        const letterRatio = letters / compact.length;
        const digitRatio = digits / compact.length;
        if (letterRatio < 0.32 && digitRatio > 0.28) {
            return "Your script reads like codes or identifiers more than prose. Paste full sentences you want voiced for the reel.";
        }
    }
    return null;
}
function longestWhitespaceDelimitedTokenLength(text) {
    return text
        .trim()
        .split(/\s+/u)
        .reduce((max, token) => Math.max(max, token.length), 0);
}
function stripAllWhitespace(text) {
    return text.replace(/\s+/gu, "");
}
